var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"non-compatible-notification\">\n<p ng-bind-html=\"$ctrl.notification_text | sanitize\"></p>\n</div>\n";
var id1="app/reservation/selections/non-compatible.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/reservation/selections/non-compatible.tpl.html
// module id = 136
// module chunks = 1 5